module.exports = __webpack_public_path__ + "static/img/Cover2.9ab49b3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Cover2.jpg
// module id = EHuA
// module chunks = 1